import { useStudies } from 'domains/viewer/Viewer/StudyLoader/useStudies';
import { WithApolloContext } from 'modules/Apollo/types';
import { FF, useFeatureFlagEnabled } from 'modules/feature-flags/suspense';
import { useMemo } from 'react';

/**
 * compartmentalized logic for determining the number of priors
 * @returns the number of priors (exams or studies depending on feature flag)
 */
export function useNumberOfPriors({ context }: WithApolloContext) {
  const enableExamGrouping = useFeatureFlagEnabled(FF.EXAM_GROUPED_HANGING_PROTOCOLS);

  const { studies, priorStudiesIds } = useStudies({ context });

  // count all unique hl7Order smids for only prior studies
  return useMemo(() => {
    if (enableExamGrouping) {
      const priorIdsSet = new Set(priorStudiesIds);

      const exams = studies.reduce((set, study) => {
        if (priorIdsSet.has(study.smid)) {
          set.add(study.hl7Order);
        }
        return set;
      }, new Set());

      return exams.size;
    }

    return priorStudiesIds.length;
  }, [enableExamGrouping, studies, priorStudiesIds]);
}
